import React, { FunctionComponent, useContext } from 'react';
import { Card } from 'components/Card';
import { EventModel } from 'features/events/EventModel';
import { liveEventSelector } from 'features/events/eventsSelectors';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useAppSelector } from 'hooks/redux';
import { LogoImage } from 'components/LogoImage';
import { ThumbImage } from 'components/Images/ThumbImage';
import buttonStyles from 'components/Buttons/styles.module.scss';
import classNames from 'classnames';

export const ChannelHomeDisabled: FunctionComponent = () => {
  const liveEvent: EventModel | null = useAppSelector(liveEventSelector);
  const { isListenerAppWebview } = useContext(UserAgentContext);
  const channel = useAppSelector((state) => state.channel.channelDetails);

  if (liveEvent && isListenerAppWebview) {
    return (
      <section className="tw-overflow-hidden tw-flex tw-flex-col tw-h-full">
        <Card
          id={liveEvent.id}
          url={`/events/${liveEvent.id}`}
          title={`${liveEvent.title}`}
          artwork={liveEvent.artwork}
          artworkMode={liveEvent.artworkMode}
          isFallback={liveEvent.fallback}
          isPrivate={liveEvent.isPrivate()}
          isActive={liveEvent.isLive()}
          updatedTimestamp={liveEvent.lastUpdatedAt}
          isFeatured={true}
          isFullScreen={true}
          type={'event'}
          color={liveEvent.color}
        />
      </section>
    );
  }

  if (isListenerAppWebview) {
    return (
      <section className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
        <div>No current live events</div>
      </section>
    );
  }

  if (channel) {
    return (
      <section className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
        <div className="tw-text-center tw-space-y-8 tw-max-w-prose tw-mx-auto">
          <LogoImage size={'medium'}>
            <ThumbImage
              artworkUrl={channel?.channelLogo.image.small}
              artworkMode={'logo'}
              alt={`Logo for ${channel?.username}`}
            />
          </LogoImage>
          <h1 className="tw-m-0">
            {channel?.username}
            <br /> is on Mixlr
          </h1>
          <div className="tw-bg-light-background tw-space-y-4 tw-p-8 tw-rounded-xl">
            <h3 className="tw-m-0">Want to do more than just listen?</h3>
            <p>Start a free trial as a Mixlr Creator</p>
            <a
              href={`${process.env.REACT_APP_URL_ENDPOINT}/priceplans`}
              className={classNames(
                buttonStyles['button'],
                buttonStyles['button--inline']
              )}
              target="_blank"
              rel="noreferrer"
            >
              Get started
            </a>
          </div>
          <p>
            Looking for creators to listen to?
            <br />
            <a
              href={`${process.env.REACT_APP_URL_ENDPOINT}/live/popular`}
              target="_blank"
              rel="noreferrer"
            >
              See who is live on Mixlr now
            </a>
          </p>
        </div>
      </section>
    );
  }

  return null;
};
